import cloneDeep from 'lodash/cloneDeep';

export function findNode(tree, nodeId) {
  const result = [];

  const findNode = node => {
    if (node.nodeId === nodeId) {
      // node found
      result.push(node);
      return true;
    }
    if (node.funds) {
      for (const fund of node.funds) {
        if (!findNode(fund))
          for (const fundInvestorTag of fund.fundInvestorTags) {
            if (findNode(fundInvestorTag)) return true;
          }
      }
    } else if (node.fundInvestorTags) {
      for (const fiTag of node.fundInvestorTags) {
        if (findNode(fiTag)) return true;
      }
    }
    return false;
  };

  for (const node of tree) {
    findNode(node);
  }
  return result.length > 0 ? result : null;
}

export function findParentNodes(tree, selectedNode, keepChildren) {
  for (const entry of tree) {
    if (entry.fundFamilyNode) {
      for (const fund of entry.funds) {
        if (fund.nodeId === selectedNode) {
          return [
            {
              ...entry,
              funds: [
                {
                  ...fund,
                  fundInvestorTags: keepChildren ? fund.fundInvestorTags : []
                }
              ]
            }
          ];
        } else {
          for (const fiTag of fund.fundInvestorTags) {
            if (fiTag.nodeId === selectedNode) {
              return [
                {
                  ...entry,
                  funds: [
                    {
                      ...fund,
                      fundInvestorTags: [fiTag]
                    }
                  ]
                }
              ];
            }
          }
        }
      }
    } else if (entry.fundNode) {
      if (entry.nodeId === selectedNode) {
        return [
          {
            ...entry,
            fundInvestorTags: keepChildren ? entry.fundInvestorTags : []
          }
        ];
      } else {
        for (const fiTag of entry.fundInvestorTags) {
          if (fiTag.nodeId === selectedNode) {
            return [
              {
                ...entry,
                fundInvestorTags: [fiTag]
              }
            ];
          }
        }
      }
    }
  }
  return null;
}

export function filterByNodeId(data, nodeId) {
  const buildNewArray = (arr, id) => {
    const newArr = [];
    for (const item of arr) {
      if (item.nodeId !== id) {
        const newItem = { ...item };

        if (newItem.fundInvestorTags) {
          newItem.fundInvestorTags = newItem.fundInvestorTags.filter(
            tag => tag.nodeId !== id
          );
        }

        if (newItem.funds) {
          newItem.funds = buildNewArray(newItem.funds, id);
        }

        if (
          newItem.nodeId !== id ||
          (newItem.fundInvestorTags && newItem.fundInvestorTags.length > 0) ||
          (newItem.funds && newItem.funds.length > 0)
        ) {
          newArr.push(newItem);
        }
      }
    }
    // removing any Fund Family that does not have funds attached
    for (const [index, value] of newArr.entries()) {
      if (value.fundFamilyNode && value.funds.length === 0) {
        newArr.splice(index, 1);
      }
    }
    return newArr;
  };

  return buildNewArray(data, nodeId);
}

export function transferFundInvestorTags(treeSelected, leftList) {
  if (treeSelected[0].fundFamilyNode) {
    // If the fund family of the selected node is present in the left-hand list.
    if (
      leftList.some(node => node.fundFamilyId === treeSelected[0].fundFamilyId)
    ) {
      return leftList.map(item => {
        const matchingTreeSelectedItem = treeSelected.find(
          data2Item => data2Item.fundFamilyId === item.fundFamilyId
        );

        if (matchingTreeSelectedItem) {
          const updatedFunds = item.funds.map(fund => {
            const matchingTreeSelectedFund = matchingTreeSelectedItem.funds.find(
              data2Fund => data2Fund.nodeId === fund.nodeId
            );

            if (matchingTreeSelectedFund) {
              return {
                ...fund,
                fundInvestorTags: [
                  ...fund.fundInvestorTags,
                  ...matchingTreeSelectedFund.fundInvestorTags.filter(
                    tag =>
                      !fund.fundInvestorTags.some(
                        existingTag => existingTag.id === tag.id
                      )
                  )
                ]
              };
            }
            return fund;
          });

          return {
            ...item,
            funds: updatedFunds
          };
        }
        return item;
      });
    } else {
      return [...leftList, ...treeSelected];
    }
  }

  // The node doesn't have a fund family
  else {
    return leftList.map(item => {
      if (item.nodeId === treeSelected[0].fundId) {
        return {
          ...item,
          fundInvestorTags: [
            ...item.fundInvestorTags,
            ...treeSelected[0].fundInvestorTags
          ]
        };
      }
      return item;
    });
  }
}

export const filterData = (
  node,
  searchFundNameQuery,
  fundFamilyId,
  selectedFundTags
) => {
  if (node.fundFamilyNode) {
    // Recursively filter the funds withing the fund family node.
    const filteredFunds = node.funds
      .map(fund =>
        filterData(fund, searchFundNameQuery, fundFamilyId, selectedFundTags)
      )
      .filter(Boolean);
    if (filteredFunds.length > 0) {
      return {
        ...node,
        filteredFunds
      };
    } else return null;
  }

  // Filter by fundName
  const matchFundName =
    !searchFundNameQuery ||
    node.fundName.toLowerCase().includes(searchFundNameQuery.toLowerCase());

  // Filter by fundFamilyId
  const matchFundFamilyId = !fundFamilyId || node.fundFamilyId === fundFamilyId;

  // Filter by fundTag IDs
  const matchFundTags =
    selectedFundTags.length === 0 ||
    selectedFundTags.some(fundTagId =>
      Object.keys(node.fundTags).includes(fundTagId.toString())
    );

  return matchFundName && matchFundFamilyId && matchFundTags;
};

export const sortList = arr => {
  arr.sort((a, b) => {
    if (a.fundFamilyNode && b.fundFamilyNode) {
      return a.fundFamilyName
        .toLowerCase()
        .localeCompare(b.fundFamilyName.toLowerCase());
    }
    if (a.fundNode && b.fundNode) {
      return a.fundName.toLowerCase().localeCompare(b.fundName.toLowerCase());
    }
    if (a.fundFamilyNode && b.fundNode) {
      return a.fundFamilyName
        .toLowerCase()
        .localeCompare(b.fundName.toLowerCase());
    }
    if (a.fundNode && b.fundFamilyNode) {
      return a.fundName
        .toLowerCase()
        .localeCompare(b.fundFamilyName.toLowerCase());
    }
    return 0;
  });

  arr.forEach(item => {
    if (item.fundFamilyNode) {
      item.funds.sort((a, b) =>
        a.fundName.toLowerCase().localeCompare(b.fundName.toLowerCase())
      );

      item.funds.forEach(fund => {
        fund.fundInvestorTags.sort((a, b) =>
          a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );
      });
    }
  });

  return arr;
};

export const mergeArrays = (arr1, arr2) => {
  const merged = [];

  const addToMerged = item => {
    if (item.fundFamilyId) {
      const existingItem = merged.find(
        el => el.fundFamilyId === item.fundFamilyId
      );
      if (existingItem && existingItem.funds) {
        existingItem.funds.push(...item.funds);
      } else if (existingItem) {
        existingItem.funds = [...item.funds];
      } else {
        merged.push(item);
      }
    } else {
      merged.push(item);
    }
  };

  arr1.forEach(addToMerged);
  arr2.forEach(addToMerged);

  return merged;
};

export const findByFundId = (data, fundId) => {
  for (const item of data) {
    if (item.funds) {
      const foundFund = item.funds.find(fund => fund.fundId === fundId);
      if (foundFund) {
        return foundFund;
      }
    } else if (item.fundId === fundId) {
      return item;
    }
  }
  return null;
};

export const findByFundInvestorTagId = (data, id, fundId) => {
  for (const entry of data) {
    if (entry.funds) {
      for (const fund of entry.funds) {
        const fiTagFound = fund.fundInvestorTags.find(fiTag => {
          return fiTag.id === id && fiTag.fundId === fundId;
        });
        if (fiTagFound) return fiTagFound;
      }
    } else {
      if (entry.fundInvestorTags) {
        const fiTagFound = entry.fundInvestorTags.find(
          fiTag => fiTag.id === id && fiTag.fundId === fundId
        );
        if (fiTagFound) return fiTagFound;
      }
    }
  }
  return null;
};

export function removeFundInvestorTags(data) {
  return data.map(item => {
    if (item.fundNode) {
      return { ...item, fundInvestorTags: [] };
    } else if (item.fundFamilyNode) {
      const updatedFunds = removeFundInvestorTags(item.funds);
      return { ...item, funds: updatedFunds };
    } else {
      return item;
    }
  });
}

export const copyState = (rightList, leftList) => ({
  copyRightList: cloneDeep(rightList),
  copyLeftList: cloneDeep(leftList)
});

export const getSelectedNodes = (selectedNodes, nodeList) =>
  selectedNodes ? selectedNodes.flatMap(node => findNode(nodeList, node)) : [];

export const handleFundFamilyNode = (
  tree,
  selectedNodeId,
  oppositeList,
  currentList
) => {
  const matchingIndex = oppositeList.findIndex(
    node => node.nodeId === tree.nodeId
  );

  if (matchingIndex !== -1) {
    oppositeList = oppositeList.map((oppositeListItem, index) =>
      index === matchingIndex
        ? {
            ...oppositeListItem,
            funds: oppositeListItem.funds.concat(tree.funds)
          }
        : oppositeListItem
    );
  } else {
    oppositeList.push(tree);
  }
  currentList = filterByNodeId(currentList, selectedNodeId);

  return { currentList, oppositeList };
};

export const handleFundNode = (nodeParent, leaf, oppositeList, currentList) => {
  if (nodeParent[0].fundFamilyNode) {
    const matchingFF = oppositeList.find(
      node => node.fundFamilyId === nodeParent[0].fundFamilyId
    );

    if (matchingFF) {
      oppositeList = oppositeList.map(oppositeListItem =>
        oppositeListItem.fundFamilyId === matchingFF.fundFamilyId
          ? {
              ...oppositeListItem,
              funds: oppositeListItem.funds.concat(nodeParent[0].funds)
            }
          : oppositeListItem
      );
    } else {
      oppositeList = [...oppositeList, ...nodeParent];
    }
  } else {
    oppositeList = [...oppositeList, ...nodeParent];
  }

  currentList = filterByNodeId(currentList, leaf.nodeId);
  return { currentList, oppositeList };
};

export const cleanSelectedNodes = selectedNodes => {
  return selectedNodes.filter(
    selectedNode =>
      (selectedNode.fundNode &&
        !selectedNodes.some(
          node =>
            node.fundFamilyNode &&
            node.fundFamilyId === selectedNode.fundFamilyId
        )) ||
      selectedNode.fundFamilyNode ||
      selectedNode.fundInvestorTagNode
  );
};
